import PokemonList from "@/views/PokemonList/PokemonList";


const firstView = PokemonList;


const urlParams = new URLSearchParams(window.location.search);
let backendUri;
let imageUri;
let battleUri;
let battleSocketUri;
if (urlParams.get('state') === "testing") {
    backendUri = "http://localhost:8000/";
    imageUri = "http://localhost:8000/";
    battleUri = "http://localhost:6969/";
    battleSocketUri = "6f46-2003-f4-3f30-e800-b060-d15b-1bd1-f2ea.ngrok-free.app";
} else {
    backendUri = "https://poketwitch.bframework.de/";
    imageUri = "https://dev.bframework.de/";
    battleUri = "https://battle.bframework.de/";
    battleSocketUri = "battle.bframework.de";
}

// backendUri = "https://dev.bframework.de/";
// imageUri = "https://dev.bframework.de/";
// battleUri = "http://localhost:6969/";

export {
    firstView,
    backendUri,
    imageUri,
    battleUri,
    battleSocketUri
};